// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface UpdateReadSupportRequestPayload {
  id: number;
}

export interface UpdateReadSupportSuccessPayload {
  read: boolean;
}

export interface UpdateReadSupportFailPayload {
  error: Error;
}

const updateReadSupportActions = createAsyncAction(
  'elearning/UPDATE_READ_SUPPORT_DATA',
  'elearning/UPDATE_READ_SUPPORT_DATA_SUCCESS',
  'elearning/UPDATE_READ_SUPPORT_DATA_FAIL'
)<
  UpdateReadSupportRequestPayload,
  UpdateReadSupportSuccessPayload,
  UpdateReadSupportFailPayload
>();

export { updateReadSupportActions as default }
